(function () {
  var popup = document.getElementById('mcn-promo-popup');
  if (!popup) return;

  var frequency = popup.dataset.frequency;
  var delay = parseInt(popup.dataset.delay, 10) * 1000;
  var storageKey = 'mcn_promo_dismissed';

  function shouldShow() {
    if (frequency === 'always') return true;
    if (frequency === 'session') {
      return !sessionStorage.getItem(storageKey);
    }
    // once per day
    var stored = localStorage.getItem(storageKey);
    if (!stored) return true;
    return Date.now() - parseInt(stored, 10) > 86400000;
  }

  function dismiss() {
    popup.classList.remove('mcn-promo-popup--visible');
    document.body.classList.remove('mcn-popup-open');
    if (frequency === 'session') {
      sessionStorage.setItem(storageKey, '1');
    } else if (frequency === 'day') {
      localStorage.setItem(storageKey, Date.now().toString());
    }
  }

  if (!shouldShow()) return;

  setTimeout(function () {
    popup.classList.add('mcn-promo-popup--visible');
    document.body.classList.add('mcn-popup-open');
  }, delay);

  var closeBtn = popup.querySelector('.mcn-promo-popup__close');
  var overlay  = popup.querySelector('.mcn-promo-popup__overlay');
  var dismissBtn = popup.querySelector('.mcn-promo-popup__dismiss');

  if (closeBtn)   closeBtn.addEventListener('click', dismiss);
  if (overlay)    overlay.addEventListener('click', dismiss);
  if (dismissBtn) dismissBtn.addEventListener('click', dismiss);
})();
